import {
    HttpEditProjectSocialWelfareConditionsPayload,
    httpEditProjectSocialWelfareConditions
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useEditSocialWelfareConditions = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpEditProjectSocialWelfareConditionsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpEditProjectSocialWelfareConditionsPayload) =>
            httpEditProjectSocialWelfareConditions({urlParams, payload}),
        // Refetch the project so the header progressStatus (backend-computed) reflects this change.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
